import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (muiTheme) => ({
    contentContainer: {
      zIndex: 0,
    },
    container: {
      '&.MuiContainer-maxWidthLg': {
        position: 'static',
      },
      '&.xsmall-height': {
        minHeight: 320,

        [muiTheme.breakpoints.up('md')]: {
          minHeight: 400,
        },
      },

      '&.small-height': {
        minHeight: 320,

        [muiTheme.breakpoints.up('md')]: {
          minHeight: 540,
        },
      },

      '&.medium-height': {
        minHeight: 380,

        [muiTheme.breakpoints.up('md')]: {
          minHeight: 650,
        },
      },

      '&.large-height': {
        minHeight: '100vh',
      },

      '&.parallax-height': {
        minHeight: '150vh',
      },

      '&.search-height': {
        minHeight: 450,
      },
    },
  }),
  { name: 'GenHero' },
);

export default useStyles;
